import React, { useState, useRef, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import isIOS from 'is-ios';

function PDFRenderComponent(props) {
	const { orientation = 'landscape', pdfData, size = 'A4', width: widthProp } = props;
	const [numPages, setNumPages] = useState(null);
	const [containerWidth, setContainerWidth] = useState(null);
	const containerRef = useRef(null);

	const onDocumentLoadSuccess = ({ numPages: pages }) => {
		setNumPages(pages);
	};

	useEffect(() => {
		if (!containerRef.current) return;
		const el = containerRef.current;
		const updateWidth = () => {
			if (el) setContainerWidth(el.offsetWidth || null);
		};
		updateWidth();
		const observer = new ResizeObserver(updateWidth);
		observer.observe(el);
		return () => observer.disconnect();
	}, [pdfData]);

	const pageWidth = widthProp == null ? containerWidth : widthProp;

	return (
		<div style={{ paddingLeft: '25%', paddingRight: '25%' }}>
			<div ref={containerRef} style={{ width: '100%', minWidth: 0 }}>
				<Document
					orientation={orientation}
					size={size}
					file={pdfData}
					onLoadSuccess={onDocumentLoadSuccess}
					onLoadError={e => console.log('PDF Render Error: ', e)}
					loading={'Loading PDF file, please wait...'}
					renderMode={isIOS ? 'svg' : 'canvas'}>
					{numPages != null &&
						Array.from({ length: numPages }, (_, i) => i + 1).map(pageNum => (
							<Page
								key={pageNum}
								pageNumber={pageNum}
								width={pageWidth || undefined}
								style={{ marginBottom: 16 }}
								renderTextLayer={false}
								renderAnnotationLayer={false}
							/>
						))}
				</Document>
			</div>
		</div>
	);
}

export default PDFRenderComponent;
